module.exports = __webpack_public_path__ + "img/header-oleo-hidraulico.6b08c64e.png";